import { useEffect, useRef, useState } from "react";
import { Volume2, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { readAloud } from "../lib/api";

let current = null;

export const SpeakButton = ({ chatId, index, big, part, load, testid = "read-aloud-btn" }) => {
  const [state, setState] = useState("idle");
  const audioRef = useRef(null);
  const reqRef = useRef(0);

  useEffect(() => () => { reqRef.current += 1; audioRef.current?.pause(); }, []);

  const stop = () => {
    reqRef.current += 1;
    audioRef.current?.pause();
    setState("idle");
  };

  const play = async () => {
    if (state === "playing" || state === "loading") return stop();
    current?.();
    const req = ++reqRef.current;
    setState("loading");
    try {
      const { url } = await (load ? load() : readAloud(chatId, index, part));
      if (req !== reqRef.current) return;
      const audio = new Audio(`${process.env.REACT_APP_BACKEND_URL}${url}`);
      audioRef.current = audio;
      audio.onended = () => setState("idle");
      audio.onerror = () => { setState("idle"); toast.error("Couldn't play the audio"); };
      await audio.play();
      if (req !== reqRef.current) return audio.pause();
      current = stop;
      setState("playing");
    } catch {
      if (req !== reqRef.current) return;
      setState("idle");
      toast.error("Couldn't read this answer aloud. Please try again.");
    }
  };

  const Icon = state === "loading" ? Loader2 : state === "playing" ? Square : Volume2;
  const label = state === "playing" ? "stop" : state === "loading" ? "loading" : big ? "Listen" : "listen";
  return (
    <button
      data-testid={testid}
      onClick={play}
      aria-label={state === "playing" ? "Stop reading" : "Read answer aloud"}
      className={big ? "what-listen-big" : "text-slate-400 hover:text-white transition-colors flex items-center gap-1.5 text-xs font-mono"}
    >
      <Icon size={big ? 16 : 13} className={state === "loading" ? "animate-spin" : ""} /> {label}
    </button>
  );
};
